import React, {useEffect } from "react";
import { Modal, ModalBody } from "react-bootstrap";

const WallpaperModal = ({ showSaveToggleValues, setShowSaveModal }) => {
  // const { popupMessage } = useContext(AccountCreateContext);
  const  popupMessage  = "Wallpaper saved successfully";

  useEffect(() => {
    if (showSaveToggleValues) {
      setTimeout(() => {
        setShowSaveModal(!showSaveToggleValues);
      }, 3000);
    }
  }, [showSaveToggleValues]);

  const smallmodalClose = () => {
    setShowSaveModal(false);
  };

  return (
    <div>
      <Modal size="sm" show={showSaveToggleValues} onHide={smallmodalClose}>
        <div
          className="d-flex flex-column align-items-center"
          style={{
            background: "whitesmoke",
            borderRadius: "5px",
            width: "100%",
          }}
        >
          <span className="d-flex ms-auto" onClick={smallmodalClose}>
            <i
              className="fe fe-x ms-auto"
              style={{
                color: "#F72B60",
                fontSize: "20px",
                cursor: "pointer",
              }}
            ></i>
          </span>
          <ModalBody
            className="d-flex align-items-center"
            style={{
              padding: "0 0 20px 0",
              justifyContent: "flex-start",
              width: "100%",
            }}
          >
            <i
              className="icon icon-check fs-30 text-success lh-1 d-inline-block"
              style={{
                marginRight: "5px",
                marginLeft: "10px",
                fontWeight: 600,
                color: "#00A269",
              }}
            ></i>
            <span style={{ fontSize: "16px", marginLeft: "10px" }}>
              {popupMessage}
            </span>
          </ModalBody>
        </div>
      </Modal>
    </div>
  );
};

export default WallpaperModal;
